import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {fetchAddErrorCode, fetchDeleteErrorCode, fetchGetAllErrorCode, fetchUpdateErrorCode} from "./actions";
import {emptyErrorCode, IErrorCode, INewErrorCode} from "../../../models/iErrorCode";

interface IPaginatedErrorCodes {
    items: IErrorCode[];
    total: number;
    page: number;
    limit: number;
}

interface IErrorCodeState {
    list: IErrorCode[];
    total: number;
    isLoading: boolean;
    currentList: INewErrorCode[];
}

const handlePending = (state: IErrorCodeState) => {
    state.isLoading = true;
};

const handleRejected = (state: IErrorCodeState) => {
    state.isLoading = false;
};

const initialState: IErrorCodeState = {
    list: [],
    total: 0,
    isLoading: false,
    currentList: [{...emptyErrorCode}],
};

export const ErrorCodeSlice = createSlice({
    name: "error_code_slice",
    initialState,
    reducers: {
        setErrorCode: (state, action: PayloadAction<IErrorCode[]>) => {
            state.list = action.payload;
        },
        setCurrentErrorCode: (state, action: PayloadAction<INewErrorCode []>) => {
            state.currentList = action.payload;
        },
        addErrorCode: (state, action: PayloadAction<INewErrorCode>) => {
            state.currentList = [...state.currentList, action.payload];
        },
        updateErrorCode: (state, action: PayloadAction<INewErrorCode>) => {
            const index = state.currentList.findIndex(
                (error) => error.tempId === action.payload.tempId
            );
            if (index !== -1) {
                state.currentList[index] = action.payload;
            }
        },
        deleteErrorCode: (state, action: PayloadAction<string>) => {
            state.currentList = state.currentList.filter(
                (error) => error.tempId !== action.payload
            );
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAddErrorCode.fulfilled, (state, action: PayloadAction<IErrorCode[]>) => {
                state.list = [...state.list, ...action.payload];
                // Сбрасываем внутреннее состояние формы после успешного добавления.
                state.currentList = [{...emptyErrorCode}];
                state.isLoading = false;
            })
            .addCase(fetchGetAllErrorCode.fulfilled, (state, action: PayloadAction<IPaginatedErrorCodes>) => {
                state.list = action.payload.items;
                state.total = action.payload.total;
                state.isLoading = false;
            })
            .addCase(fetchUpdateErrorCode.fulfilled, (state, action: PayloadAction<IErrorCode>) => {
                state.list = [...state.list.map(item => item.id === action.payload.id ? action.payload : item)]
                state.isLoading = false;
            })
            .addCase(fetchDeleteErrorCode.fulfilled, (state, action: PayloadAction<string>) => {
                state.list = [...state.list.filter(item => item.id !== action.payload)]
                state.isLoading = false;
            })
            .addCase(fetchAddErrorCode.pending, handlePending)
            .addCase(fetchAddErrorCode.rejected, handleRejected)
            .addCase(fetchGetAllErrorCode.pending, handlePending)
            .addCase(fetchGetAllErrorCode.rejected, handleRejected)
            .addCase(fetchUpdateErrorCode.pending, handlePending)
            .addCase(fetchUpdateErrorCode.rejected, handleRejected)
            .addCase(fetchDeleteErrorCode.pending, handlePending)
            .addCase(fetchDeleteErrorCode.rejected, handleRejected);
    },
});

export const {
    setErrorCode,
    setCurrentErrorCode,
    addErrorCode,
    updateErrorCode,
    deleteErrorCode
} = ErrorCodeSlice.actions;
export default ErrorCodeSlice.reducer;